export enum ReadonlyStateKey {
  Readonly = 'readonly',
}

export interface StudentSectionReadonlyState {
  [ReadonlyStateKey.Readonly]?: boolean;
}
